import React from 'react';
import Button from "../../components/Button";
import { HOST } from "../../constants/Fetch";
const phoneRegEx = /[\s()-]/g;


const ContactPerson = props => (
  <div className="vacancyCard__contactPerson">
    {
      props.person.image && <img className="vacancyCard__contactPhoto" src={HOST + props.person.image} alt={props.person.last_name} />
    }
    <div className="vacancyCard__contactTitle">Контактное лицо</div>
    <div className="vacancyCard__contactName">{props.person.first_name} {props.person.last_name}</div>
    {
      props.person.phone &&
      <a className="vacancyCard__contactInfo" href={`tel:${props.person.phone.replace(phoneRegEx, "")}`}>
        {props.person.phone}
        {props.person.personal_phone && ` (доб. ${props.person.personal_phone})` }
      </a>
    }
    {
      props.person.email &&
      <a className="vacancyCard__contactInfo" href={`mailto:${props.person.email}`}>{props.person.email}</a>
    }
    {
      props.isInternship ?
      <Button smooth link="#toInternshipForm" text="Откликнуться" modifier="button--xs button--marginBottom" /> :
      <Button smooth link="#toVacancyForm" text="Откликнуться" modifier="button--xs button--marginBottom" />
    }
  </div>
)

export default ContactPerson;



// WEBPACK FOOTER //
// ./src/components/ContactPerson/index.js